import { PROMO } from 'constants/EntryPoint';
import { NO_AUTH_VIEW } from 'constants/ServerConstants';

import HelpArticleDeeplinkPage from 'pages-no-auth/help/HelpArticleDeeplinkPage';

import { FOOTER_TYPE_DEFAULT, LANG_COUNTRY } from './routeConstant';

const deepLinkNoAuth = () => {
    const slugs = [
        'cash-pickup-in-mexico',
        'cash-pickup-in-nigeria',
        'cash-pickup-in-philippines',
        'cash-payout-in-philippines',
        'cash-pickup-in-vietnamese-banks',
        'cash-pickup-in-vietcombank',
        'cash-pickup-in-chedraui-stores',
        'cash-pickup-in-isseg-pharmacies',
        'home-delivery-in-vietnam',
        'bank-transfer-to-south-africa',
        'canada-interac-payment-method',
        'cash-pickup-in-lebanon',
        'canada-interac',
        'transfer-via-weixin',
        'weconnect',
    ];

    const baseStrapiApi = '/api/v2/help-article/';
    const basePathData = {
        component: HelpArticleDeeplinkPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        exact: true,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            entryPoint: PROMO,
            footerType: FOOTER_TYPE_DEFAULT,
            ogType: 'article',
        },
    };

    let finalPaths = [];
    slugs.forEach((slug) => {
        finalPaths.push({
            path: ['/' + slug, `/${LANG_COUNTRY}/help/transfers/` + slug],
            ...basePathData,
            stateOptions: { ...basePathData.stateOptions, strapiApi: baseStrapiApi + slug },
        });
    });

    return finalPaths;
};

export default deepLinkNoAuth(); // Intentionally calling it here
